import React from "react";
// import { Navbars } from "../../layout/Navbar/Navbars";
import { Outlet } from "react-router-dom";
import { Navbars } from "../../../layout/UserPortal/Navbar/Navbars";
import { Footer } from '../../../layout/footer/footer'

const Home = () => {
    return (
        <>
            <Navbars />
            <Outlet />
            <Footer/>
            
        </>
    )

}
export default Home;